import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { EnergySummary } from '../interfaces/responses/models';

@Injectable({
  providedIn: 'root'
})
export class EnergySummaryService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  private createCompleteUrl(path: string): string {
    return `${this.apiUrl}${path}`;
  }

  getEnergySummary(): Observable<EnergySummary> {
    return this.http.get<EnergySummary>(this.createCompleteUrl('energy/summary'));
  }
}